import {getPageData} from '../sources/CmsSource';
import {useStore} from '../stores';
import {useEffect, useReducer} from 'react';
import produce from 'immer';

/**
 * Async function which checks for the cms page and fetches if needed
 * @param {store, setStore}  The objects returned from useStore() hook
 * @param {*} cmsUrlPattern String path of a cms page i.e. /home
 */
const getPage = async (dispatch, cmsUrlPattern) => {
    dispatch({type: 'loading', cmsUrlPattern});
    const response = await getPageData(cmsUrlPattern);
    dispatch({type: 'pageData', payload: response, cmsUrlPattern});
};

const reducer = (draft, {type, payload, cmsUrlPattern}) => {
    switch (type) {
        case 'pageData': {
            draft.loading = false;
            if (!payload || !payload._urlPattern) {
                draft[cmsUrlPattern] = {
                    error404: true
                };
            } else {
                draft[cmsUrlPattern] = payload;
            }
            break;
        }
        case 'loading': {
            draft.loading = true;
            draft.loadingSlug = cmsUrlPattern;
            break;
        }
        default:
            break;
    }
};

/**
 * Hook for wiring up the async functions and getting page data for a React functional component
 * @param {*} cmsUrlPattern String path of a cms page i.e. /home
 */
export const useGetPageData = ({cmsUrlPattern}) => {
    const [store] = useStore();
    const cms = store.cms || {};
    const [state, dispatch] = useReducer(produce(reducer), cms);
    const pageData = state[cmsUrlPattern];

    useEffect(() => {
        if (!pageData) {
            //if don't already have the page
            getPage(dispatch, cmsUrlPattern);
        }
    }, [pageData, cmsUrlPattern, getPage, dispatch]);

    return pageData;
};
